<template>
  <div id="app">
    <Hero
      title="Creative Development & Digital Services"
      subtitle="We build websites, web applications, media installations and help you measure your
            success along the way."
    ></Hero>
    <router-view></router-view>
    <site-footer></site-footer>
    <contact-modal></contact-modal>
  </div>
</template>

<script>
import Hero from "./hero/index.vue";
import SiteFooter from "./site-footer/index.vue";
import ContactModal from "./contact-modal/index.vue";

export default {
  data() {
    return {};
  },
  mounted() {
    this.$store.dispatch("fetchProjects");
    this.$store.dispatch("fetchServices");
    this.$store.dispatch("fetchJobs");
  },
  components: {
    Hero,
    SiteFooter,
    ContactModal
  }
};
</script>

<style lang="scss">
$primary: #16738f;
$primary-lightest: #38b6db;
$primary-lighter: #187d9c;
$primary-darker: #125e75;
$primary-darkest: #053442;

$cta1: #dbcd17;
$cta2: #9c284a;

.container-fluid {
  max-width: 1100px;
  margin: 0 auto;

  &.fullwidth {
    max-width: 100%;
  }
}

#app {
  font-family: NexaBook;

  .section {
    padding: 5rem 0;
  }
  a.is-primary {
    background: $primary;
    text-transform: uppercase;
    font-family: NexaLight;
    font-size: 18px;
    line-height: 18px;
    padding-bottom: 0;
    &.is-outlined {
      background: none;
      border-color: $primary;
      color: $primary;
      &:hover {
        background: $primary;
        color: white;
      }
    }
  }

  .page-header {
    .heading {
      font-family: NexaBook;
      font-weight: bold;
      color: $primary-lightest;
      margin-bottom: 0.5rem;
      font-size: 12px;
    }

    .title {
      font-family: NexaLight;
      font-weight: normal;
      letter-spacing: 0.05rem;
      color: $primary-darkest;
      margin: 0.5rem;
    }
    p {
      font-size: 18px;
      margin-bottom: 2rem;
    }
  }

  .field {
    position: relative;
    margin-bottom: 2rem;
    .label {
      position: absolute;
      z-index: 10;
      top: 8px;
      left: 8px;
      pointer-events: none;
      transform-origin: 0%;
      opacity: 0.5;
      transition: all 0.25s ease-in-out;
      color: $primary;
    }
    .input,
    .textarea {
      border: none;
      box-shadow: none;
      border-bottom: 2px solid $primary;
      border-radius: 0;

      &:focus + .label,
      &:active + .label {
        opacity: 1;
        transform: translate(-8px, -24px) scale(0.8);
      }
      &.hasContent + .label {
        transform: translate(-8px, -24px) scale(0.8);
      }
    }
  }
  .notification {
    &.is-primary {
      background: white;
      border: 1px solid $primary-lightest;
      color: $primary-lightest;
      font-size: 18px;
    }
    &.is-danger {
      background: white;
      border: 1px solid darkred;
      color: darkred;
      font-size: 18px;
    }
  }
}
</style>
